<template>
    <div>
        <div v-if="loading" class="p-5 text-center text-muted">
            <hollow-dots-spinner :animation-duration="1000" :dot-size="10" :dots-num="3" color="#6F787D"/>
            <div class="mt-3 font-size-08">Carregando...</div>
        </div>

        <div v-else-if="erro" class="alert alert-danger" role="alert">
            <i class="fas fa-exclamation-triangle mr-2" aria-hidden="true"></i>
            Não foi possível carregar os dados. <button type="button" class="btn btn-sm btn-link p-0 align-baseline" v-on:click="carregar()">Tentar novamente</button>
        </div>

        <div v-else-if="anexo">
            <slot name="anexo" v-bind="{anexo: anexo, refresh: carregar}"></slot>
        </div>

        <div v-else>
            <slot v-bind="{refresh: carregar}"></slot>
        </div>
    </div>
</template>

<script>
    import {bus} from '../../app';
    import {HollowDotsSpinner} from 'epic-spinners';

    export default {
        components: {HollowDotsSpinner},
        props: {
            url: {type: String, required: true},
            refresh_emit: {type: String, required: true},
        },
        data() {
            return {
                loading: true,
                erro: false,
                anexo: null,
                _refreshHandler: null,
            }
        },
        methods: {
            carregar() {
                this.loading = true;
                this.erro = false;
                window.axios.get(this.url)
                    .then(res => {
                        this.anexo = (res.data && res.data.anexo) ? res.data.anexo : null;
                        this.loading = false;
                    })
                    .catch(() => {
                        this.erro = true;
                        this.loading = false;
                    });
            },
        },
        created() {
            this._refreshHandler = () => { this.carregar(); };
            bus.$on(this.refresh_emit, this._refreshHandler);
        },
        destroyed() {
            bus.$off(this.refresh_emit, this._refreshHandler);
        },
        mounted() {
            this.carregar();
        },
    }
</script>
